import { render, staticRenderFns } from "./pubResource.vue?vue&type=template&id=b3c4aef6&"
import script from "./pubResource.vue?vue&type=script&lang=js&"
export * from "./pubResource.vue?vue&type=script&lang=js&"
import style0 from "./pubResource.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports